import { toast } from 'sonner'

export const handleFormSubmission = async ({
  createMutation,
  updateMutation,
  reset,
  setOpen,
  isUpdate = false,
  successMessageDescription,
  successMessageTitle,
  hideToast = false,
}: {
  createMutation?: () => Promise<void>
  updateMutation?: () => Promise<void>
  reset?: () => void
  setOpen?: (data: boolean) => void
  isUpdate?: boolean
  successMessageDescription?: string
  successMessageTitle?: string
  hideToast?: boolean
}) => {
  try {
    if (isUpdate) {
      if (updateMutation) await updateMutation()
    } else {
      if (createMutation) await createMutation()
    }
    if (reset) reset()

    if (setOpen) setOpen(false)

    if (!hideToast) {
      const title = successMessageTitle ?? (isUpdate ? 'Updated successfully' : 'Created successfully')
      const toastOptions = successMessageDescription ? { description: successMessageDescription } : undefined

      toast.success(title, toastOptions)
    }
  } catch (error: unknown) {
    toast.error(error instanceof Error ? error?.message : 'Something went wrong')
    throw error
  }
}
